import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">
            影视专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            精心策划的影视合集，帮你快速找到想看的类型
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              className="group block p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <span className="whitespace-nowrap flex-shrink-0 ml-2 px-2.5 py-1 rounded-md text-xs font-medium bg-secondary-100 text-secondary-700">
                  {item.tag}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
              <div className="flex items-center gap-1 mt-4 text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                <span>进入专题</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}